import type {
  schemaType,
  returnType,
} from '~~/shared/api/strapi/cottages-page/schema'
import {
  strapiServerFetchWrapper,
  strapiBrowserFetchWrapper,
} from '~~/server/utils/strapi/endpointWrapper'

const endpoint = '/cottages-page'

export const serverFetch = (): Promise<returnType> =>
  strapiServerFetchWrapper<never, schemaType>(endpoint)

export const browserFetch = (): Promise<returnType> =>
  strapiBrowserFetchWrapper<never, schemaType>(endpoint)
